"use client";

import * as React from "react";
import { BookOpen, FileText, Briefcase, Users, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Cittadinanza",
  description: "Consulenza esperta per l'acquisizione della cittadinanza italiana e internazionale, con gestione completa delle pratiche burocratiche.",
  icon: FileText,
  link: "/VisasAndImmigrationPage"
}, {
  title: "Traduzioni Giurate",
  description: "Servizi di traduzione e legalizzazione documenti con valore legale, essenziali per ogni procedura di mobilità internazionale.",
  icon: BookOpen,
  link: "/ExtrajudicialPage"
}, {
  title: "Mobilità Aziendale",
  description: "Supporto strategico per il trasferimento di dipendenti e dirigenti, garantendo conformità normativa e rapidità d'esecuzione.",
  icon: Briefcase,
  link: "/CompanyServicesPage"
}, {
  title: "Studenti e Istituti",
  description: "Programmi dedicati per l'inserimento accademico internazionale e la gestione dei visti per motivi di studio e ricerca.",
  icon: Users,
  link: "/StudentsAndInstitutesPage"
}];
export default function StudentServicesDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="242962" id="ambiti-di-intervento" className="bg-background text-foreground py-16 md:py-24">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-primary mb-4 tracking-tight">
            Ambiti di Intervento
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Soluzioni professionali e integrate per la mobilità globale, progettate per garantire eccellenza e affidabilità in ogni fase del processo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="flex flex-col h-full border-secondary/30 bg-white/5 backdrop-blur-sm shadow-sm hover:shadow-xl hover:shadow-secondary/10 hover:-translate-y-1 transition-all duration-500 rounded-sm">
                <CardHeader className="pb-4">
                  <div className="size-12 rounded-sm bg-secondary/10 flex items-center justify-center mb-4 text-secondary">
                    <Icon className="size-6" />
                  </div>
                  <CardTitle className="text-xl font-default text-primary">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="text-muted-foreground leading-relaxed font-default text-sm">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-4 border-t border-secondary/10 mt-auto">
                  <Button variant="ghost" className="w-full justify-between group hover:bg-secondary/10 hover:text-secondary text-primary font-default" asChild>
                    <Link to={service.link}>
                      Scopri di più
                      <ArrowRight className="size-4 text-secondary shrink-0 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}